import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { UserRole } from '../../../models/domain.models';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'vx-register',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  template: `
    <section class="auth-shell">
      <form class="auth-card" [formGroup]="form" (ngSubmit)="submit()">
        <span class="eyebrow">Onboarding</span>
        <h1>Crea account VaulTriX</h1>
        <div class="roles">
          @for (role of roles; track role.value) {
            <button type="button" [class.active]="form.value.ruolo === role.value" (click)="form.patchValue({ ruolo: role.value })">{{ role.label }}</button>
          }
        </div>
        <div class="form-field"><label>Nome</label><input formControlName="nome"></div>
        <div class="form-field"><label>Azienda / struttura</label><input formControlName="azienda"></div>
        <div class="form-field"><label>Email</label><input formControlName="email" type="email"></div>
        <div class="form-field"><label>Telefono</label><input formControlName="telefono"></div>
        <div class="form-field"><label>Password</label><input formControlName="password" type="password"></div>
        @if (error()) { <strong class="error">{{ error() }}</strong> }
        <button class="btn primary" type="submit">Crea account</button>
        <a routerLink="/login">Hai gia un account? Accedi</a>
      </form>
    </section>
  `,
  styles: [`
    .auth-shell {
      min-height: 76vh;
      display: grid;
      place-items: center;
      padding: 70px 16px;
    }
    .auth-card {
      width: min(560px, 100%);
      display: grid;
      gap: 16px;
      padding: 30px;
      border-radius: 14px;
      background: white;
      box-shadow: var(--vx-shadow);
    }
    h1 { margin: 0; font-family: "Space Grotesk"; font-size: 2.1rem; }
    .roles {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 8px;
    }
    .roles button {
      border: 1px solid var(--vx-line);
      border-radius: 8px;
      padding: 10px;
      background: white;
      cursor: pointer;
      font-weight: 800;
      color: var(--vx-muted);
    }
    .roles button.active {
      color: white;
      background: linear-gradient(135deg, var(--vx-primary), var(--vx-secondary));
    }
    a { color: var(--vx-muted); }
    .error { color: var(--vx-danger); }
    @media (max-width: 620px) { .roles { grid-template-columns: 1fr 1fr; } }
  `]
})
export class RegisterComponent {
  private readonly fb = inject(FormBuilder);
  private readonly api = inject(ApiService);
  private readonly router = inject(Router);
  protected readonly error = signal('');
  protected readonly roles: Array<{ label: string; value: UserRole }> = [
    { label: 'Utente', value: 'user' },
    { label: 'Azienda', value: 'partner' },
    { label: 'Ente pubblico', value: 'public_entity' },
    { label: 'Operatore', value: 'operator' }
  ];

  protected readonly form = this.fb.nonNullable.group({
    nome: ['', Validators.required],
    azienda: [''],
    email: ['', [Validators.required, Validators.email]],
    telefono: [''],
    ruolo: ['user' as UserRole, Validators.required],
    password: ['', [Validators.required, Validators.minLength(8)]]
  });

  submit() {
    if (this.form.invalid) {
      this.error.set('Completa i campi obbligatori. La password deve avere almeno 8 caratteri.');
      return;
    }
    this.api.register(this.form.getRawValue()).subscribe((res) => {
      localStorage.setItem('vx_token', res.access_token);
      localStorage.setItem('vx_user', JSON.stringify(res.user));
      this.router.navigateByUrl('/dashboard');
    });
  }
}
